import { useEffect, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import {
  DropdownContent,
  DropdownItem,
  dropDownStore,
  DropdownTextInput,
  Scrollbar,
  SpinnerLoader,
} from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type IIntegrationDropdownItem } from 'widgets/IntegrationDropdown/store/types'
import { useIntegrationDropdownContext } from '../context/integrationDropdownContext'
import styles from './styles.module.scss'

type IIntegrationContentProps = {
  dropdownId: string
  onCloseMenu: () => void
}

export const IntegrationContent: FC<IIntegrationContentProps> = observer(
  ({ dropdownId, onCloseMenu }) => {
    const { search, setIntegrationSearch, integrationsLoading, integrationItems, setIntegration } =
      useIntegrationDropdownContext()

    useEffect(() => {
      return () => {
        setIntegrationSearch('')
      }
    }, [])

    if (integrationsLoading) {
      return (
        <DropdownContent>
          <div className={styles.loader}>
            <SpinnerLoader ariaLabel={'IntegrationContent'} size={20} />
          </div>
        </DropdownContent>
      )
    }

    return (
      <DropdownContent noPadding>
        <DropdownTextInput
          textFieldProps={{
            value: search,
            onChange: setIntegrationSearch,
            InputProps: {
              placeholder: 'Search',
            },
          }}
        />

        <Scrollbar
          autoHeight
          autoHeightMin={0}
          autoHeightMax={208}
          onScroll={() => {
            dropDownStore.allHide(dropdownId)
          }}
        >
          <DropdownContent>
            {integrationItems.map((integrationItem) => (
              <DropdownItem
                key={integrationItem.id}
                item={integrationItem}
                onChange={(item) => {
                  const integrationItem = item as IIntegrationDropdownItem
                  if (integrationItem.data?.isConnected === false) {
                    onCloseMenu()
                    uiStore.changeRoute({
                      path: '/settings/integrations',
                    })
                    return
                  }
                  setIntegration(integrationItem)
                  onCloseMenu()
                }}
              />
            ))}
            {!integrationItems.length && <div className={styles.noResult}>No results found</div>}
          </DropdownContent>
        </Scrollbar>
      </DropdownContent>
    )
  }
)
